import { render, staticRenderFns } from "./RoomCall.vue?vue&type=template&id=5d5c2f66&scoped=true&"
import script from "./RoomCall.vue?vue&type=script&lang=js&"
export * from "./RoomCall.vue?vue&type=script&lang=js&"
import style0 from "./RoomCall.vue?vue&type=style&index=0&id=5d5c2f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c2f66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5c2f66')) {
      api.createRecord('5d5c2f66', component.options)
    } else {
      api.reload('5d5c2f66', component.options)
    }
    module.hot.accept("./RoomCall.vue?vue&type=template&id=5d5c2f66&scoped=true&", function () {
      api.rerender('5d5c2f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/RoomCall.vue"
export default component.exports